import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GameButton',
  props: {
  disabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  cancel: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  small: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_dig_ui_standard_button = _resolveComponent("dig-ui-standard-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["game-button", { cancel: __props.cancel, small: __props.small }])
  }, [
    _createVNode(_component_dig_ui_standard_button, { disabled: __props.disabled }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["disabled"])
  ], 2))
}
}

})